import { FC } from 'react';
import { useTranslation } from 'src/i18n';
import {
  Button,
  Dialog,
  DialogProps,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from 'material-hu';

export type ErrorDialogProps = DialogProps & {
  onAccept?: (event) => void;
  message?: string;
};

export const ErrorDialog: FC<ErrorDialogProps> = (props) => {
  const {
    onAccept,
    message,
    ...dialogProps
  } = props;

  const { t } = useTranslation();

  return (
    <Dialog {...dialogProps}>
      <DialogTitle>
        {t('ERROR')}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {message || t('ERROR_GENERAL')}
        </Typography>
      </DialogContent>
      {onAccept && (
        <DialogActions>
          <Button onClick={onAccept}>
            {t('ACCEPT')}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ErrorDialog;
